/**Constant strings used in the app. */
export const stringConst = {
    APP_NAME: "Coffee Game" as const,
    APP_DESCRIPTION: "Find the number and pay the coffee!" as const,
    
    NAV_GAME_PAGE: "🎮 Game" as const,
    NAV_SETTINGS_PAGE: "⚙️ Settings" as const,
    NAV_HOWTO_PAGE: "💡 How To" as const,

    GAME_PAGE: "Game Match" as const,
    SETTINGS_PAGE: "Settings" as const,
    HOWTO_PAGE: "How To" as const,

    START_NEW_GAME: "🎮 Start a new game 🎮" as const,
    
    STARTINGPLAYER_SETTINGS: "Random starting player" as const,
    PLAYERORDER_SETTINGS: "Random player order" as const,

    SUCCESS_RANGE_SETTINGS: "Range settings updated!" as const,
    WARNING_RANGE_SETTINGS: "No changes to save!" as const,

    SUCCESS_PLAYERS_SETTINGS: "Players settings updated!" as const,
    WARNING_PLAYERS_SETTINGS: "No changes to save!" as const,
    DANGER_PLAYERS_SETTINGS: "Player already exists!" as const,
    INFO_PLAYERS_SETTINGS: "Get random nickname..." as const,

    SUCCESS_STARTINGPLAYER_SETTINGS: "Starting player settings updated!" as const,
    SUCCESS_PLAYERORDER_SETTINGS: "Player order settings updated!" as const
};